import type { PromotionFormValues } from '~/lib/schemas/promotion';

/**
 * Canonical demo policy — "Καλοκαιρινές Εκπτώσεις 2026" (00-handoff.md).
 * Used for development hydration (editor id="demo") and as the Zod parse fixture
 * in tests. Lookup ids (category/customer-category/gift products) are placeholders
 * for dev only; real ids come from the lookup endpoints (Phase E/F/I).
 */
export const DEMO_POLICY: PromotionFormValues = {
	id: 0,
	name: 'Καλοκαιρινές Εκπτώσεις 2026',
	code: 'SUMMER2026',
	priority: 5,
	description: 'Καλοκαιρινές προσφορές σε σχολικά βοηθήματα.',
	badgeText: 'ΚΑΛΟΚΑΙΡΙ',
	badgeImageUrl: null,
	backgroundImageUrl: null,
	frontLabel: null,
	colorHex: null,
	backgroundColorHex: null,
	externalUrl: null,
	isActive: true,
	isVisible: true,
	hideFromOffers: false,
	activeFrom: new Date('2026-06-15'),
	activeTo: new Date('2026-08-31'),
	minAmount: 50,
	maxAmount: null,
	minQuantity: null,
	appliesToSelectedProducts: false,
	productMatchCondition: 'any',
	productSelectionConditionMode: 'and',
	productIds: [],
	categoryIds: [1234], // "Σχολικά Βοηθήματα" (placeholder id)
	manufacturerIds: [],
	customerCategoryIds: [1], // "Εγγεγραμμένοι" (placeholder id)
	customerIds: [],
	customerGroupIds: [],
	siteIds: [],
	applyToSiteMode: 'all',
	actions: [
		{
			type: 'percentage-discount',
			combineWithOthers: true,
			tierMode: 'byAmount',
			tiers: [
				{ id: 't1', threshold: 50, value: 10 },
				{ id: 't2', threshold: 100, value: 15 },
				{ id: 't3', threshold: 150, value: 20 }
			],
			applyOnDiscountedProducts: 'onFinal'
		},
		{
			type: 'gift-product',
			combineWithOthers: false,
			maxSelections: 1,
			productIds: [101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112],
			prompts: [
				{ locale: 'el', text: 'Επιλέξτε το δώρο σας' },
				{ locale: 'en', text: 'Choose your gift' }
			]
		}
	]
};
